import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './checkbox.module.scss';

const Checkbox = ({
  label,
  name,
  checked,
  value,
  fullLine,
  onChange,
  success,
  customId,
  dense = false,
  disabled = false,
  className,
  ...rest
}) => (
  <div
    className={cn(
      styles.checkbox,
      dense && styles.dense,
      disabled && styles.disabled,
      className
    )}
  >
    <input
      type="checkbox"
      checked={checked}
      id={customId ? `${customId}-${name}` : name}
      value={value}
      onChange={disabled ? undefined : onChange}
      disabled={disabled}
      {...rest}
    />
    <label
      className={`${fullLine ? styles.labelFullLine : ''} ${
        success ? styles.success : ''
      }`}
      htmlFor={customId ? `${customId}-${name}` : name}
    >
      {label}
    </label>
  </div>
);

Checkbox.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
    PropTypes.bool.isRequired,
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  success: PropTypes.bool,
  dense: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default Checkbox;
